var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-pdf"},[_c('a',{staticClass:"pdf column-center",attrs:{"href":_vm.server+_vm.data.archivo,"target":"_blank"}},[_c('img',{attrs:{"src":("/static/img/novedades-" + _vm.lang + ".webp"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b60718","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/area-tecnica/tip-novedad.vue
// module id = null
// module chunks = 